/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-29 07:46:53
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Spinner, Tooltip } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Compact from 'src/components/views/analytics/display/grid/compact';
import Detail from 'src/components/views/analytics/display/grid/detail';
import { ANALYTICS } from 'src/constants/message';

type Props = WithI18nProps;
class TopSearchTerms extends Component<Props> {
  state = {
    // List of top filter option values
    topSearchTerms: [],
    defaultTopSearchTerms: [],
    errorRequest: false
  };

  componentDidMount() {
    // Initial value for state
    const { topSearchTerms } = this.props;
    const defaultTopSearchTerms = _.isArray(topSearchTerms) ? topSearchTerms.slice(0, 5) : [];

    this.setState({
      topSearchTerms,
      defaultTopSearchTerms
    });
  }

  componentWillReceiveProps(nextProps) {
    const { loading } = this.props;
    const { loading: nextLoading, success: nextSuccess } = nextProps;

    // Check new data from API
    if (loading && !nextLoading && nextSuccess) {
      const { topSearchTerms } = nextProps;
      const defaultTopSearchTerms = _.isArray(topSearchTerms) ? topSearchTerms.slice(0, 5) : [];

      this.setState({
        topSearchTerms,
        defaultTopSearchTerms
      });
    }

    if (loading && !nextLoading && !nextSuccess) {
      this.setState({ errorRequest: true });
    }
  }

  render() {
    const { topSearchTerms, defaultTopSearchTerms, errorRequest } = this.state;
    const { loading, compare, id, blockDetailId, moneyFormat, i18n } = this.props;
    const isDetail = id === blockDetailId;

    return (
      <Card
        sectioned
        title={
          <Tooltip
            content={i18n.translate('AdminHTML.Analytics.Searches.topSearchTerms_TooltipContent')}
            preferredPosition="above">
            <span className="Polaris-Heading">
              {i18n.translate('AdminHTML.Analytics.Searches.topSearchTerms_TooltipChildren')}
            </span>
          </Tooltip>
        }
        actions={[
          {
            content: isDetail
              ? i18n.translate('AdminHTML.Common.Action.hide')
              : i18n.translate('AdminHTML.Common.Action.viewDetail'),
            onAction: this.changeShowHideDetail
          }
        ]}>
        {loading ? (
          <div className="spinner-loading">
            <Spinner
              accessibilityLabel={i18n.translate(
                'AdminHTML.Analytics.Common.spinner_AccessibilityLabel'
              )}
              size="large"
            />
          </div>
        ) : _.isEmpty(topSearchTerms) ? (
          <div className="analytic-empty">
            {errorRequest
              ? i18n.translate(ANALYTICS.ERROR_REQUEST)
              : i18n.translate('AdminHTML.Analytics.Searches.topSearchTerms_AnalyticEmpty')}
          </div>
        ) : isDetail ? (
          //Show detail
          <Detail
            listData={topSearchTerms}
            compare={compare}
            type="searchTerm"
            moneyFormat={moneyFormat}
          />
        ) : (
          // Show compact
          <Compact
            listData={defaultTopSearchTerms}
            compare={compare}
            collectionLabel=""
            type="searchTerm"
            moneyFormat={moneyFormat}
          />
        )}
      </Card>
    );
  }

  changeShowHideDetail = () => {
    const { changeShowHideDetail, id } = this.props;
    changeShowHideDetail(id);
  };
}

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = (state, props) => {
  // Get format money, help to display price
  const moneyFormat = _.get(state.oauth.tenantApp, 'externalInfo.money_format', '');

  return {
    compare: _.get(state.analytics, 'compare', false),
    loading: _.get(state.analytics, `topSearchTermsLoading`, false),
    success: _.get(state.analytics, `topSearchTermsSuccess`, false),
    topSearchTerms: _.get(state.analytics, `topSearchTerms`, []),
    moneyFormat
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(TopSearchTerms));
